export default __webpack_public_path__ + "6cde99bda487909604d389c364be7d67.svg";